import Vue from 'vue';

export default {
  getDevelopmentList(params) {
    return Vue.axios.get('/api/v1.0/system/news/list', {params});
  }
};
